"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get NC_DATA_REFLECTION_SETTINGS () {
        return NC_DATA_REFLECTION_SETTINGS;
    },
    get createDatabaseUser () {
        return createDatabaseUser;
    },
    get dropDatabaseUser () {
        return dropDatabaseUser;
    },
    get genPassword () {
        return genPassword;
    },
    get genSuffix () {
        return genSuffix;
    },
    get generateWhereClause () {
        return generateWhereClause;
    },
    get grantAccessToSchema () {
        return grantAccessToSchema;
    },
    get revokeAccessToSchema () {
        return revokeAccessToSchema;
    }
});
const _nanoid = require("nanoid");
var _process_env_NC_PUBLIC_URL;
const NC_DATA_REFLECTION_SETTINGS = {
    host: process.env.NC_DATA_REFLECTION_HOST || ((_process_env_NC_PUBLIC_URL = process.env.NC_PUBLIC_URL) == null ? void 0 : _process_env_NC_PUBLIC_URL.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, '')),
    port: +process.env.NC_DATA_REFLECTION_PORT || 5433
};
const genSuffix = (0, _nanoid.customAlphabet)('1234567890abcdef', 6);
const genPassword = ()=>(0, _nanoid.nanoid)(128);
const grantAccessToSchema = async (knex, schema, username)=>{
    const query = `
  GRANT USAGE ON SCHEMA :schema: TO :username:;
  GRANT SELECT ON ALL TABLES IN SCHEMA :schema: TO :username:;
  GRANT USAGE, SELECT ON ALL SEQUENCES IN SCHEMA :schema: TO :username:;
  ALTER DEFAULT PRIVILEGES IN SCHEMA :schema: GRANT SELECT ON TABLES TO :username:;
  ALTER DEFAULT PRIVILEGES IN SCHEMA :schema: GRANT USAGE, SELECT ON SEQUENCES TO :username:;
  `;
    const preparedQuery = knex.raw(query, {
        schema,
        username
    }).toQuery();
    await knex.raw(preparedQuery);
};
const revokeAccessToSchema = async (knex, schema, username)=>{
    const query = `
  REVOKE ALL ON SCHEMA :schema: FROM :username:;
  REVOKE ALL PRIVILEGES ON ALL TABLES IN SCHEMA :schema: FROM :username:;
  REVOKE ALL PRIVILEGES ON ALL SEQUENCES IN SCHEMA :schema: FROM :username:;
  ALTER DEFAULT PRIVILEGES IN SCHEMA :schema: REVOKE ALL ON TABLES FROM :username:;
  ALTER DEFAULT PRIVILEGES IN SCHEMA :schema: REVOKE ALL ON SEQUENCES FROM :username:;
  `;
    const preparedQuery = knex.raw(query, {
        schema,
        username
    }).toQuery();
    await knex.raw(preparedQuery);
};
const createDatabaseUser = async (knex, username, password, database)=>{
    const query = `
  CREATE USER :username: WITH PASSWORD :password;
  REVOKE ALL ON SCHEMA public FROM :username:;
  REVOKE ALL PRIVILEGES ON ALL TABLES IN SCHEMA public FROM :username:;
  REVOKE TEMPORARY ON DATABASE :database: FROM :username:;
  GRANT CONNECT ON DATABASE :database: TO :username:;
  ALTER ROLE :username: SET statement_timeout = '60s';
  ALTER ROLE :username: SET idle_in_transaction_session_timeout = '60s';
  `;
    const preparedQuery = knex.raw(query, {
        username,
        password,
        database
    }).toQuery();
    await knex.raw(preparedQuery);
};
const dropDatabaseUser = async (knex, username, database)=>{
    const query = `
  REVOKE ALL ON DATABASE :database: FROM :username:;
  DROP USER IF EXISTS :username:;
  `;
    const preparedQuery = knex.raw(query, {
        username,
        database
    }).toQuery();
    await knex.raw(preparedQuery);
};
function inInterceptor(table, column, values) {
    return {
        type: 'binary_expr',
        operator: 'in',
        left: {
            type: 'column_ref',
            table,
            column: {
                expr: {
                    type: 'default',
                    value: column
                }
            }
        },
        right: {
            type: 'expr_list',
            value: values.map((schema)=>({
                    type: 'string',
                    value: schema
                }))
        }
    };
}
function eqInterceptor(table, column, value) {
    return {
        type: 'binary_expr',
        operator: '=',
        left: {
            type: 'column_ref',
            table,
            column: {
                expr: {
                    type: 'default',
                    value: column
                }
            }
        },
        right: {
            type: 'string',
            value
        }
    };
}
function generateWhereClause(table, column, type, value) {
    if (type === 'in') {
        return inInterceptor(table, column, Array.isArray(value) ? value : [
            value
        ]);
    }
    return eqInterceptor(table, column, value);
}
